import { useMemo } from "react";

import type { IAggregatedEventListItem } from "~/types/aggregatedEventListItem";
import type { IAggregatedEvent } from "~/types/event";

interface IUseGroupedEventCountDownResult {
  hideCountdown: boolean;
}

export const useGroupedEventCountDown = (
  event: IAggregatedEventListItem | IAggregatedEvent
): IUseGroupedEventCountDownResult => {
  const hideCountdown = useMemo(() => {
    const isGroupedEvents = (event.eventCount || 0) > 1;

    if (!isGroupedEvents || !event.groupedEvents.length) {
      return false;
    }

    const normalizedDates = event.groupedEvents
      .map((groupedEvent) => groupedEvent.endDate)
      .map((date) => {
        if (!date) {
          return null;
        }

        const parsedDate = new Date(date);

        if (Number.isNaN(parsedDate.getTime())) {
          return null;
        }

        return Math.floor(parsedDate.getTime() / 1000);
      });

    if (normalizedDates.some((date) => date === null)) {
      return true;
    }

    return new Set(normalizedDates).size > 1;
  }, [event.eventCount, event.groupedEvents]);

  return { hideCountdown };
};
